module.exports = __webpack_public_path__ + "static/img/eureka_icon_5.763a8e33.png";